export default "__VITE_ASSET__BX$HHDeP__"